/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Provider } from "react-redux";
import "./productCarousel.scss";
import ct from "class-types.macro";
import Store from "~/common/Store";
import { CarouselItem } from "./Carousel/CarouselItem";
import CarouselMember from "./Carousel/CarouselMember";
import { OtherProductsCarouselPromotion } from "./ProductDetailPageResult";
import OtherProductsCarouselPromotionMember from "./OtherProductsCarouselPromotionMember";
import RequestQuoteSlide from "./Carousel/Slides/RequestQuoteSlide";
interface Props {
  carouselItems: CarouselItem[];
  otherProductsCarouselPromotionMember: OtherProductsCarouselPromotion;
}
const OtherProductsInThisLineCarousel = ({
  carouselItems,
  otherProductsCarouselPromotionMember
}: Props) => {
  const hasActiveSale = carouselItems.some(item => item.displaySalePrice);
  return <Provider store={Store} data-sentry-element="Provider" data-sentry-component="OtherProductsInThisLineCarousel" data-sentry-source-file="OtherProductsInThisLineCarousel.tsx">
      <div className="carousel-wrap">
        <div className={`clearfix ${ct("bg-white", "border-gray-200", "border-solid", "border-0", "border-t", "p-3", "xs:bg-transparent", "xs:border-none", "xs:border-t-0", "xs:p-0")}`}>
          <div className="carousel-wrap__header">
            <h3 className={`${ct("mb-0", "xs:mb-4")}`}>
              Other Products from this Line
            </h3>
          </div>
        </div>
        <div data-component="other-products-from-this-line-carousel" id="other-products-from-this-line-carousel-atc" className="carousel-wrap" gtm-carousel-name="Other Products from this Line">
          <div className="carousel-box" data-component="carousel">
            <div className="ag-carousel-nav">
              <a className="ag-car-prev" data-control="prev" />
              <a className="ag-car-next" data-control="next" />
            </div>
            <div id="otherProductsCarousel" className="ag-carousel-frame box" data-testid="other-products-carousel">
              <ul className="ag-carousel ag-mini">
                {otherProductsCarouselPromotionMember.showShopAllTile && <OtherProductsCarouselPromotionMember image={otherProductsCarouselPromotionMember.image} url={otherProductsCarouselPromotionMember.url} text={otherProductsCarouselPromotionMember.text} />}
                {carouselItems.map((carouselItem, index) => carouselItem.isRequestQuoteEnabled ? <li className="ag-item">
                      <RequestQuoteSlide item={carouselItem} />
                    </li> : <CarouselMember item={carouselItem} showAddToCart addToCartFormId={`relatedproduct_other-products-from-this-line_${index}`} key={index} activeSalePricingClassNames={hasActiveSale ? "h-[37px]" : "h-[22px]"} isMiniCarousel />)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Provider>;
};
export default OtherProductsInThisLineCarousel;